"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollapseExample = void 0;
var tslib_1 = require("tslib");
var mithril_1 = tslib_1.__importDefault(require("mithril"));
var _1 = require("@/");
var examples_1 = require("@shared/examples");
var EXAMPLE_SRC = 'components/collapse/examples/index.ts';
var SAMPLE_TEXT = 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis interdum ex eu eros dictum.<br/><br/>';
var CollapseExample = /** @class */ (function () {
    function CollapseExample() {
        var _this = this;
        this.isOpen = false;
        this.content = [SAMPLE_TEXT];
        this.appendContent = function () {
            _this.content.push(SAMPLE_TEXT);
        };
        this.toggleOpen = function () {
            _this.isOpen = !_this.isOpen;
        };
    }
    CollapseExample.prototype.view = function () {
        return (0, mithril_1.default)(examples_1.Example, { center: false, src: EXAMPLE_SRC }, [
            (0, mithril_1.default)(_1.Button, {
                label: this.isOpen ? 'Hide collapse' : 'Show collapse',
                intent: 'primary',
                onclick: this.toggleOpen,
                style: 'margin-right: 10px'
            }),
            (0, mithril_1.default)(_1.Button, {
                label: 'Append content',
                onclick: this.appendContent
            }),
            (0, mithril_1.default)(_1.Collapse, { duration: 200, isOpen: this.isOpen }, [
                (0, mithril_1.default)(_1.Card, { style: 'margin-top:20px' }, this.content.map(function (text) { return mithril_1.default.trust(text); }))
            ])
        ]);
    };
    return CollapseExample;
}());
exports.CollapseExample = CollapseExample;
